// Helper to normalize solution data
export const normalizeSolutionData = (doc) => {
  if (!doc.exists()) return null;

  const data = doc.data();
  if (!data) return null;

  return {
    id: doc.id,
    ...data,
    // Ensure creatorUsername exists for UI (fallback to legacy/user fields)
    creatorUsername: data.creatorUsername || data.userName || data.username || data.displayName || data.name || null,
    // Ensure creatorProfession exists for UI (fallback to legacy/user fields)
    creatorProfession: data.creatorProfession || data.profession || data.userProfession || null,
    // Ensure userId exists for profile navigation (fallback to legacy fields)
    userId: data.userId || data.ownerId || data.authorId || data.createdBy || data.creatorId || null,
    // Map creatorUsername to userName for backward compatibility
    userName: data.creatorUsername || data.userName,
    createdAt: (() => {
      const ms = getMillisFromTimestamp(data.createdAt);
      if (typeof ms === 'number') return new Date(ms).toISOString();
      return typeof data.createdAt === 'string' ? data.createdAt : null;
    })(),
    updatedAt: (() => {
      const ms = getMillisFromTimestamp(data.updatedAt);
      if (typeof ms === 'number') return new Date(ms).toISOString();
      return typeof data.updatedAt === 'string' ? data.updatedAt : null;
    })(),
    voters: data.voters || [],
    likes: data.likes || 0,
    likers: data.likers || [],
    saves: data.saves || 0,
    savers: data.savers || [],
    shares: data.shares || 0,
    sharers: data.sharers || []
  };
};

// Helper to extract millis from Firestore Timestamp or Date-like
export const getMillisFromTimestamp = (ts) => {
  try {
    if (!ts) return null;
    if (typeof ts.toMillis === 'function') return ts.toMillis();
    if (typeof ts.toDate === 'function') {
      const d = ts.toDate();
      return typeof d?.getTime === 'function' ? d.getTime() : null;
    }
    if (ts instanceof Date) return ts.getTime();
    if (typeof ts.seconds === 'number') {
      const nanos = typeof ts.nanoseconds === 'number' ? ts.nanoseconds : 0;
      return ts.seconds * 1000 + Math.floor(nanos / 1e6);
    }
    return null;
  } catch (_) {
    return null;
  }
};

// Simple tokenizer used for search word arrays
export const tokenizeWords = (str) => {
  if (!str || typeof str !== 'string') return [];
  const parts = str.toLowerCase().split(/[^a-z0-9]+/gi).filter(Boolean);
  const seen = new Set();
  const out = [];
  for (const p of parts) { if (!seen.has(p)) { seen.add(p); out.push(p); } }
  return out;
};
